import axios from 'axios';

const signupFormVerify = async (token: string, verifyEndpoint: string) => {
  const apiUrl = `${verifyEndpoint}${'?X-ECID-Token='}${token}`;
  const { status } = await axios.get(apiUrl);

  return status;
};

export default signupFormVerify;
